import React, {useEffect, useRef, useState} from 'react';
import {ProForm, ProFormInstance} from '@ant-design/pro-form';
import {FormPageProps} from '@/components/WdiBus/FormPage';
import {wdiCore, WdiModalAppResult} from "@/components/WdiControls";
import {WdiButtonContainer} from "@/components/WdiBus/Buttons";
import {ResponseStatus} from "@/utils/request";
import { Spin, Tabs} from "antd";
import TabPane from "@ant-design/pro-card/lib/components/TabPane";
import {ProductPolicy} from "@/services/policy/productpolicy";
import {initPageContext} from "@/pages/policy/ProductPolicyApply/data";
import ProductPolicySoldToApplyPanel from "@/pages/policy/ProductPolicyApply/components/SoldTo/soldTo";
import ProductPolicyHistoryForApprovalPanel from "@/pages/policy/ProductPolicyApproval/components/ProductPolicyHistory";
import ProductPolicyBasicApprovalPanel from "@/pages/policy/ProductPolicyApproval/components/basic";
import ProductPolicyDetailApprovalPanel from "@/pages/policy/ProductPolicyApproval/components/detail";
import {ProductPolicyMoreWapper} from "@/pages/policy/ProductPolicy/Button";
import {OpenModeEnum} from "@/pages/policy/ProductPolicyApply/components/apply";
import {
  ProductPolicyTargetForApprovalPanel
} from "@/pages/policy/ProductPolicyApply/components/PolicyTarget/ProductPolicyTargetPanel";


const ProductPolicyApprovalApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [soldToDataSource, setSoldToDataSource] = useState<Array<API.ProductPolicySoldTo>>([]);
  const [targetDataSource, setTargetDataSource] = useState<Array<API.ProductPolicyTargetQuery>>([]);
  const [policyDataSource, setPolicyDataSource] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false);
  const [entity,setEntity] = useState<any>();

  useEffect(() => {
    (async () => {
      const result: WdiModalAppResult = await initPageContext(props.data?.productPolicyId)
      if (result.code != ResponseStatus.SUCCESS) return;
      const entity = result.data;
      let title = '政策【' + entity.policyCode + '】'
      const activeName = entity.isActive ? "有效" : "无效";
      title = wdiCore.String.Join(title, activeName, '，')
      if (props.setPageTitle) props.setPageTitle(
        <div>
          <span>{title}</span>
          <WdiButtonContainer>
            <ProductPolicyMoreWapper
              url={"/expenseapi/policyButtons/get"}
              buttonKeys={["ReeditPolicyButton", "CopyButton", "InvalidateButton"]}
              items={[
                {name: "productPolicyId", value: props.data?.productPolicyId}
              ]}
              callback={() => {
                if (props.callback) {
                  props.callback?.();
                  props.onClose?.();
                }
              }}
            />
          </WdiButtonContainer>
        </div>
      )

      result.data.policyDate = result.data.startDate + " - " + result.data.endDate;
      formRef.current?.setFieldsValue(result.data);
      setSoldToDataSource(result.data?.productPolicySoldToList ?? []);
      setTargetDataSource(result.data?.productPolicyTargetList ?? []);
      const policyDataSourceRes = await ProductPolicy.searchProductPolicyHistory({productPolicyId: props.data?.productPolicyId});
      if (policyDataSourceRes.code != ResponseStatus.SUCCESS) return;
      setPolicyDataSource(policyDataSourceRes.data);
      setEntity(entity);
      setLoading(false)
    })()
  }, [props.data])


  return (
    <>
      <Tabs defaultActiveKey="1" size="large" className={'wdi-form'}>
        <TabPane tab={<span>政策信息</span>} key="1">
          <ProForm
            formRef={formRef}
            submitter={{
              render: () => {
                return (<></>);
              },
            }}
          >
            {loading ? <Spin/> : <>
              <ProductPolicyBasicApprovalPanel formRef={ formRef } />

              <ProductPolicyDetailApprovalPanel formRef={ formRef }
                                                entity={entity}
                                                openMode={ OpenModeEnum.VIEW } />

              <ProductPolicySoldToApplyPanel dataSource={ soldToDataSource }
                                             openMode={ OpenModeEnum.VIEW }
                                             onChange={ (data: React.SetStateAction<API.ProductPolicySoldTo[]>) => setSoldToDataSource(data) } />
              <br/>
              <ProductPolicyTargetForApprovalPanel dataSource={targetDataSource}/>
            </>}
          </ProForm>
        </TabPane>
        <TabPane tab={<span>动态信息</span>} key="2">
          {loading ? <Spin/> : <ProductPolicyHistoryForApprovalPanel
            dataSource={policyDataSource}/>}
        </TabPane>
      </Tabs>
    </>
  );
}
export default ProductPolicyApprovalApp;
